import ThesisDisertation from '../profile/components/ThesisDisertation'
import Education from './components/Education'
import Experience from './components/Experience'
import Language from './components/Language'
import Other from './components/Others'
import {Overview} from './components/Overview'
import PersonalInformation from './components/Personalnformation'
import Skill from './components/Skill'

const tabsMenuAlumni = [
  {
    title: 'Ringkasan',
    path: '/crafted/pages/profile/basic-overview',
    isActive: false,
    component: Overview,
  },

  {
    title: 'Informasi Personal',
    path: '/crafted/pages/profile/personal-information',
    isActive: false,
    component: PersonalInformation,
    isSeparator: true,
  },

  {
    title: 'Pendidikan',
    path: '/crafted/pages/profile/education',
    isActive: false,
    component: Education,
    isSeparator: true,
  },

  {
    title: 'Pengalaman Kerja',
    path: '/crafted/pages/profile/experience',
    isActive: false,
    component: Experience,
    isSeparator: true,
  },

  {
    title: 'Keahlian',
    path: '/crafted/pages/profile/skill',
    isActive: false,
    component: Skill,
    isSeparator: true,
  },

  {
    title: 'Bahasa',
    path: '/crafted/pages/profile/language',
    isActive: false,
    component: Language,
    isSeparator: true,
  },
  {
    title: 'Tesis & Disertasi',
    path: '/crafted/pages/profile/thesis-and-disertation',
    isActive: false,
    component: ThesisDisertation,
    isSeparator: true,
  },
  {
    title: 'Lainnya',
    path: '/crafted/pages/profile/other',
    isActive: false,
    component: Other,
    isSeparator: true,
  },
]

export default tabsMenuAlumni
